<template>
  <fragment>
    <AppBody
      :subtitle="pageSubtitle"
      :menuTitle="$t('events.create-event')"
      :actions="pageActions"
    >
      <CardModule untitle>
        <ExpansionPanelFilters>
          <v-form @submit.prevent="filterEvents" class="search-forms">
            <v-row>
              <v-col cols="12" md="3" sm="4">
                <BaseTextField
                  :label="$t('events.event-description')"
                  :placeholder="$t('events.event-description-example')"
                  v-model="filter.descricao"
                  data-cy="descricao"
                ></BaseTextField>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseSelect
                  :items="$produtos_gerenciar.categorias_produtos"
                  @click:clear="filter.categoria = ''"
                  clearable
                  data-cy="Status"
                  v-model="filter.idcategoria"
                  item-text="descricao"
                  item-value="idcategoria"
                  :label="$t('events.category')"
                  :placeholder="$t('events.select-category')"
                ></BaseSelect>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseSelect
                  :items="statusOptions"
                  @click:clear="filter.status = ''"
                  clearable
                  data-cy="Status"
                  v-model="filter.status"
                  item-text="item"
                  item-value="value"
                  label="Status"
                  :placeholder="$t('events.select-status')"
                ></BaseSelect>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseSelect
                  :items="filtredSalesChannel()"
                  @click:clear="filter.canal_venda = ''"
                  clearable
                  v-model="filter.canal_venda"
                  data-cy="canal-vendas"
                  item-text="value"
                  item-value="key"
                  :label="$t('events.channel-sales')"
                  :placeholder="$t('events.select-channel-sales')"
                ></BaseSelect>
              </v-col>
              <v-col class="d-flex justify-end">
                <BaseButton variant="filter" data-cy="filtrar" type="submit">
                  {{ $t("events.filter") }}
                </BaseButton>
              </v-col>
            </v-row>
          </v-form>
        </ExpansionPanelFilters>

        <v-data-table
          class="table-body"
          :no-data-text="$t('events.no-events-found')"
          :loading-text="$t('events.loading-info')"
          :loading="eventsLoading"
          :headers="headersProdutos"
          :items="tableValues"
          :items-per-page="10"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 50],
            itemsPerPageText: $t('events.events-per-page'),
          }"
        >
          <template v-slot:header.estoque="{ header }">
            <span class="mr-16">{{ header.text }}</span>
          </template>
          <template v-slot:item.estoque="{ item }">
            <span class="mr-16"> {{ item.estoque }}</span>
          </template>
          <template v-slot:header.status="{ header }">
            <span>{{ header.text }}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-select
              :items="statusOptions"
              v-model="item.status"
              item-text="value"
              item-value="key"
              style="width: 130px"
              hide-details
              @change="
                changeEventStatus({ id: item.idproduto, status: item.status })
              "
              class="pa-0 ma-0"
              :disabled="disableAction"
            >
              <template v-slot:selection="{ item }">
                <span>
                  <v-chip small :color="getColorChipStatus(item.value)">{{
                    item.item
                  }}</v-chip>
                </span>
              </template>
            </v-select>
          </template>
          <template v-slot:item.action="{ item }" class="table-actions">
            <div class="d-flex justify-start align-center">
              <v-tooltip bottom v-if="isCustomTax(item)">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-switch
                      disabled
                      block
                      dense
                      :input-value="true"
                      color="black"
                      inset
                    />
                  </div>
                </template>
                <span>{{ $t("new-event.tooltip-event") }}</span>
              </v-tooltip>
              <div v-else class="d-flex justify-start align-center">
                <v-switch
                  :disabled="disableAction"
                  block
                  dense
                  v-model="item.tipo_taxa_web"
                  inset
                  @click="$produtos_gerenciar.reverterTaxa(item.idproduto)"
                  true-value="CONVENIENCIA"
                  false-value="COMISSAO"
                  persistent-hint
                />
              </div>
              <p>
                {{
                  isCustomTax(item)
                    ? $t("events.custom")
                    : item.tipo_taxa_web == "CONVENIENCIA"
                    ? $t("events.convenience")
                    : $t("events.comission")
                }}
              </p>
            </div>
          </template>

          <template v-slot:item.actions="{ item }" class="table-actions">
            <div style="display: flex; justify-content: center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    height="30"
                    width="30"
                    small
                    :disabled="!hasTicketVariation(item) || disableAction"
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="openModal(item)"
                    class="mr-2"
                  >
                    <v-icon>mdi-ticket-confirmation-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("events.variations") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    :disabled="
                      isEventProfile ||
                      (item.tipo !== 'EVENTO' && item.tipo !== 'LINK')
                    "
                    height="30"
                    width="30"
                    small
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="confirmDouble(item.idproduto)"
                    class="mr-2"
                  >
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("events.duplicate") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    :disabled="disableAction"
                    height="30"
                    width="30"
                    small
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="
                      $produtos_gerenciar.getProdutoById(
                        item.idproduto,
                        item.tipo === 'EVENTO' || item.tipo === 'LINK'
                          ? 'editar-evento'
                          : 'editar'
                      )
                    "
                    class="mr-2"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("events.edit") }}</span>
              </v-tooltip>
              <v-tooltip v-if="isAdmin" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    width="30"
                    height="30"
                    v-bind="attrs"
                    v-on="on"
                    @click="openBinsModal(item)"
                    small
                    icon
                  >
                    <v-icon> mdi-credit-card-edit-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("events.bins-integration") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    height="30"
                    class="mr-2"
                    :disabled="item.libera_acesso_disable"
                    v-bind="attrs"
                    v-on="on"
                    width="30"
                    small
                    icon
                    @click="
                      $produtos_gerenciar.sendToProductLoja(
                        item.slug,
                        item.tipo,
                        item.url_link
                      )
                    "
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("events.access") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-if="isAdmin" v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    width="30"
                    height="30"
                    v-bind="attrs"
                    v-on="on"
                    @click="exportAccessTypes(item.idproduto)"
                    :disabled="isExportationDisabled(item.circus)"
                    small
                    icon
                  >
                    <v-icon> mdi-boom-gate-up-outline </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("events.export-access-types") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    :disabled="isEventProfile"
                    height="30"
                    v-bind="attrs"
                    v-on="on"
                    width="30"
                    small
                    icon
                    @click="confirmRemove(item.idproduto)"
                  >
                    <v-icon> mdi-delete-outline </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("events.delete") }}</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </CardModule>
    </AppBody>
    <TicketModal
      :dialog="isOpenModal"
      :editedItem="modalInfo"
      @close="closeModal"
    />
    <ModalBins
      v-if="binsModal"
      :dialog="binsModal"
      :event-data="eventData"
      @close="binsModal = false"
    />
    <ConfirmAction
      :dialog.sync="confirmDoubleEvent"
      :title="$t('double-event-title')"
      :subtitle="$t('double-event-subtitle')"
      @action="fetchDoubleEvent"
      @close="cancelDoubleEvent"
    />
    <ConfirmAction
      :dialog.sync="confirmDelete"
      :title="$t('delete-event-title')"
      :subtitle="$t('delete-event-subtitle')"
      @action="removeImage"
      @close="cancelRemove"
    />
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import dayjs from "dayjs";
import products from "@/mixins/products.js";
import _ from "lodash";
import { filtredSalesChannel } from "@/utils";

export default {
  name: "Events",
  metaInfo() {
    const title = this.$t("events.title");
    return {
      title: `${title} | ElevenTickets`,
      meta: [
        {
          property: "og:title",
          content: `${title} | ElevenTickets`,
        },
      ],
    };
  },
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    CardModule: () => import("@/components/cards/CardModule.vue"),
    BaseTextField: () => import("@/components/forms/BaseTextField.vue"),
    BaseSelect: () => import("@/components/forms/BaseSelect.vue"),
    BaseButton: () => import("@/components/forms/BaseButton.vue"),
    ConfirmAction: () =>
      import("@/components/events/EventSettingsModal/ConfirmAction.vue"),
    TicketModal: () => import("./TicketModal.vue"),
    ModalBins: () =>
      import("@/components/produtos/gerenciar/bins/ModalBins.vue"),
    ExpansionPanelFilters: () =>
      import("@/components/forms/ExpansionPanelFilters.vue"),
  },
  props: {},
  mixins: [products],
  data() {
    return {
      filtredSalesChannel,
      eventData: null,
      binsModal: false,
      isOpenModal: false,
      modalInfo: null,
      dayjs,
      filter: {
        descricao: "",
        idcategoria: "",
        status: "",
        canal_venda: "",
      },
      confirmDoubleEvent: false,
      doubleEventItem: null,

      confirmDelete: false,
      itemDelete: null,
    };
  },
  computed: {
    ...mapGetters([
      "allEvents",
      "editEvent",
      "eventsLoading",
      "isAdmin",
      "isEventProfile",
      "storeSequencial",
      "isStoreKeeper",
    ]),
    statusOptions() {
      return [
        {
          item: this.$t("new-event.settings.status.active").toUpperCase(),
          value: "ATIVO",
        },
        {
          item: this.$t("new-event.settings.status.inactive").toUpperCase(),
          value: "INATIVO",
        },
        {
          item: this.$t("new-event.settings.status.sold-out").toUpperCase(),
          value: "ESGOTADO",
        },
        {
          item: this.$t("new-event.settings.status.draft").toUpperCase(),
          value: "RASCUNHO",
        },
      ];
    },
    actions() {
      if (this.isStoreKeeper) {
        return [
          {
            name: this.$t("events.create-event"),
            action: () =>
              this.$produtos_gerenciar.getProdutoById("", "new-event"),
          },
        ];
      } else {
        return [
          {
            name: this.$t("events.create-event"),
            action: () =>
              this.$produtos_gerenciar.getProdutoById("", "new-event"),
          },
          {
            name: this.$t("events.create-event-link"),
            action: () =>
              this.$produtos_gerenciar.getProdutoById("", "new-link"),
          },
        ];
      }
    },
    pageSubtitle() {
      if (this.$produtos_gerenciar.loja_prod)
        return (
          `${this.$t("events.title")} - ` + this.$produtos_gerenciar.loja_prod
        );
      return this.$t("events.title");
    },
    pageActions() {
      return this.isEventProfile ? [] : this.actions;
    },
    disableAction() {
      return this.editEvent === 0 && this.isEventProfile;
    },
    tableValues() {
      if (this.allEvents.length > 0) {
        let filteredEvents = this.allEvents;
        if (this.isStoreKeeper) {
          filteredEvents = filteredEvents.filter(prod => prod.tipo !== "LINK");
        }

        filteredEvents.forEach(prod => {
          switch (prod.canal_venda) {
            case "PDV_POS;ECOMMERCE;IFRAME;LINK":
              prod.canal_venda = this.$t("events.pos-web-sale");
              break;
            case "PDV_POS":
              prod.canal_venda = this.$t("events.pos-sale");
              break;
            case "ECOMMERCE;IFRAME;LINK":
            case "ECOMMERCE;IFRAME":
              prod.canal_venda = this.$t("events.web-sale");
              break;
            case "PDV_POS;ECOMMERCE;IFRAME":
              prod.canal_venda = this.$t("events.pos-web-sale");
              break;
            case "CORTESIA":
              prod.canal_venda = this.$t("events.courtesy");
              break;
            default:
              break;
          }
          prod.descricao = this.$config.convertTagString(prod.descricao);
          prod.estoque = prod.qtd_estoque || prod.qtd_estoque_var || 0;

          if (prod.status == "ATIVO") {
            if (prod.dthr_termino === "1969-12-31 21:00:00") {
              prod.libera_acesso_disable = false;
            } else if (dayjs().isAfter(dayjs(prod.dthr_termino))) {
              prod.libera_acesso_disable = true;
            } else if (prod.gerenciar_estoque == 1) {
              prod.libera_acesso_disable = prod.estoque > 0 ? false : true;
            } else if (prod.gerenciar_estoque == 0) {
              prod.libera_acesso_disable = false;
            } else {
              prod.libera_acesso_disable = true;
            }
          } else {
            prod.libera_acesso_disable = true;
          }
        });
        return _.orderBy(filteredEvents, "ins_dthr", "desc");
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions([
      "exportAccessTypes",
      "fetchEvents",
      "changeEventStatus",
      "doubleEvent",
      "showSnackbarSuccess",
    ]),
    isCustomTax(item) {
      return !item?.reverter_taxa;
    },
    openModal(item) {
      this.isOpenModal = true;
      this.modalInfo = item;
    },
    closeModal() {
      this.isOpenModal = false;
      this.modalInfo = {};
    },
    isExportationDisabled(circus) {
      return circus == 0 ? true : false;
    },
    filterEvents() {
      let filters = [];
      if (this.filter.descricao) {
        filters.push({
          campo: "prod.descricao",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.descricao,
        });
      }

      if (this.filter.idcategoria) {
        filters.push({
          campo: "prod.idcategoria",
          tipo: "string",
          valor: this.filter.idcategoria,
        });
      }

      if (this.filter.status) {
        filters.push({
          campo: "prod.status",
          tipo: "string",
          valor: this.filter.status,
        });
      }

      if (this.filter.canal_venda) {
        filters.push({
          campo: "prod.canal_venda",
          tipo: "string",
          valor: this.filter.canal_venda,
        });
      }

      this.fetchEvents({
        producerId: this.storeSequencial,
        ...filters,
      });
    },
    openBinsModal(item) {
      this.binsModal = true;
      this.eventData = {
        descricao: item.descricao,
        idproduto: item.idproduto,
        variantes: item.variantes,
      };
    },
    getColorChipStatus(status) {
      switch (status) {
        case "ATIVO":
          return "success";
        case "INATIVO":
          return "error";
        case "ESGOTADO":
          return "warning";
        default:
          return "info";
      }
    },
    hasTicketVariation(item) {
      return item.variantes.variacoes_produto.some(variation => {
        return variation.tipo === "INGRESSO";
      });
    },
    confirmDouble(item) {
      this.confirmDoubleEvent = true;
      this.doubleEventItem = item;
    },
    cancelDoubleEvent() {
      this.confirmDoubleEvent = false;
      this.doubleEventItem = null;
    },
    async fetchDoubleEvent() {
      try {
        await this.doubleEvent(this.doubleEventItem);
        this.showSnackbarSuccess(this.$t("double-event-success"));
        this.doubleEventItem = null;
        this.confirmDoubleEvent = false;
      } catch (error) {
        console.error(error);
      }
    },
    confirmRemove(index) {
      this.confirmDelete = true;
      this.itemDelete = index;
    },
    cancelRemove() {
      this.confirmDelete = false;
      this.itemDelete = null;
    },
    removeImage() {
      this.showSnackbarSuccess(this.$t("delete-event-success"));
      this.$produtos_gerenciar.deletarProduto(this.itemDelete);
      this.confirmDelete = false;
      this.itemDelete = null;
    },
  },
  mounted() {
    this.$produtos_gerenciar.getStatusProdutos();
    this.$produtos_gerenciar.getTiposProdutos();
    this.$produtos_gerenciar.getProdutosCategoria();
    this.$produtos_gerenciar.getCanaisVenda();
    this.fetchEvents({ producerId: this.storeSequencial, filtro: [] });
  },
  destroyed() {
    this.$produtos_gerenciar.limpaFiltros();
    this.$produtos_gerenciar.produtos = [];
  },
};
</script>

<style scoped>
.table-actions {
  height: 67px !important;
  min-height: 67px !important;
  margin-bottom: 0px !important;
}
</style>
